import {FETCH_MY_EVENTS, FETCH_EVENTS, LISTEN_ADMIN_EVENTS, LISTEN_CONFIRMED_EVENTS, LISTEN_CONNECTED_EVENTS} from '../constants/actionTypes'

const INITIAL_STATE = {
    eventList: null,
    myEvents: null,
    adminEvents: null,
    connectedEvents: null,
    confirmedEvents: null,
    myConfirmedEvents: null,
    myConfirmedEventsCounter: 0,
      
  };

  const applyFetchEvents = (state, action) => {
    return ({
    ...state,
    eventList: action.payload
  })}

  const applyListenAdminEvents = (state, action) => {
    return ({
    ...state,
    adminEvents: action.payload ? action.payload : []
  })}

  const applyFetchMyEvents = (state, action) => {
    return ({
    ...state,
    myEvents: action.myEventsArr  
  })}

  function eventReducer(state = INITIAL_STATE, action) {
    switch(action.type) {
      case FETCH_EVENTS : {
        return applyFetchEvents(state, action);
      }
      case LISTEN_ADMIN_EVENTS : {
        return applyListenAdminEvents(state, action);
      }
      case FETCH_MY_EVENTS : {
        return applyFetchMyEvents(state, action);
      }
      case LISTEN_CONNECTED_EVENTS : {
        return ({
        ...state,
        connectedEvents: action.payload

      })}
      case LISTEN_CONFIRMED_EVENTS : {
        
        return ({
        ...state,
        confirmedEvents: action.payload
      })}
      case 'MY_CONFIRMED_EVENTS' : {
    
        return ({
        ...state,
        myConfirmedEvents: action.payload.event,
        myConfirmedEventsCounter: action.payload.counter,
      })}
  
      default : return state;
    }
  }
  
  export default eventReducer;


// WEBPACK FOOTER //
// ./src/reducers/event.js